import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import NavLink from './NavLink';

export default class LogoutLink extends PureComponent {
  static contextTypes = {
    session: PropTypes.object.isRequired
  };

  logout = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    this.context.session.logout();
  };

  render() {
    const { className, style } = this.props;
    return (

      <NavLink
        style={style}
        className={className}
        page={null}
        href={'/'}
        linkClasses="color-white"
        id="logOutLink"
        name="logOutLink"
        onClick={this.logout}
        target="_self"
      >
        <i className="fa fa-sign-out fa-xs" aria-hidden="true" style={{ marginRight: 8 }}/>
        Log Out
      </NavLink>
    );
  }
}